export default "__VITE_ASSET__1e71ca9f__"